export default "__VITE_ASSET__D5W4TLJ4__"